module.exports = __webpack_public_path__ + "img/LayaBurger.690e4685.svg";